import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
    ShowAlert: "SHOW_ALERT",
    HideAlert: "HIDE_ALERT",
};

const initialAlertState = {
    isVisible: false,
    message: "",
    variant: "success",
};

export const reducer = (state = initialAlertState, action) => {

    switch (action.type) {
        case actionTypes.ShowAlert: {
            return {
                isVisible: true,
                message: action.payload.message,
                variant: action.payload.variant,
            };
        }

        case actionTypes.HideAlert: {
            return {
                ...state,
                isVisible: false
            };
        }

        default:
            return state;
    }
};

export const actions = {
    showAlert: (model) => ({ type: actionTypes.ShowAlert, payload: model }),
    hideAlert: () => ({ type: actionTypes.HideAlert }),
};
